const WIDGET_TYPES = new Set([
  'usage_limit_reached',
  'betting_options',
  'search_lotteries',
  'quick_pick',
  'lotteries_last_results',
  'lottery_draw_history',
]);

export const isWidgetIntent = (a2ui) => {
  const type = a2ui?.components?.[0]?.type;
  return !!type && WIDGET_TYPES.has(type);
};
